<template>
  <div>
    <div class="foot">
      <div class="main">
<!--        <div class="t">
          <div class="t-list">
            <div class="t-li">
              <span class="icon zp"></span>
              <span>{{$t('genuineProductGuarantee')}}</span>
            </div>
            <div class="t-li">
              <span class="icon sh"></span>
              <span>{{$t('afterAll')}}</span>
            </div>
            <div class="t-li">
              <span class="icon ts"></span>
              <span>{{$t('characteristicService')}}</span>
            </div>
            <div class="t-li">
              <span class="icon pl"></span>
              <span>{{$t('theCategoryIsComplete')}}</span>
            </div>

            <div class="t-li">
              <span class="icon js"></span>
              <span>{{$t('speedDistribution')}}</span>
            </div>
          </div>
        </div> -->
        <div class="m">
          <div class="ml" v-for="(list,index) in bottomList" :key="index">
            <div class="mlli">
              <div class="mlli-title">{{list.name}}</div>
              <ul>
                <li v-for="(item,i) in list.children" :key="i">
                  <a :href="item.url" v-if="item.type==1" target="_blank">{{item.name}}</a>
                  <!--url -->
                  <router-link :to="{name:'help',query:{type:item.type,id:item.data}}" v-if="item.type==2">{{item.name}}</router-link>
                  <!--文章分类 -->
                  <router-link :to="{name:'help',query: {article_id:item.article_id}}" v-if="item.type==3">{{item.name}}</router-link>
                  <!--文章详情 -->
                  <router-link :to="{name:'search',query:{name: item.name,id:item.id}}" v-if="item.type==4">{{item.name}}</router-link>
                  <!--商品列表 -->
                  <router-link :to="{name:'detail',params: {goodsId:item.val}}" v-if="item.type==5">{{item.name}}</router-link>
                  <!--商品详情 -->
                  <router-link v-if="item.type==6">{{item.name}}</router-link>
                  <!--二级菜单 -->
                </li>
              </ul>
            </div>
          </div>
          <div class="mr">

<!--           <div class="title">Payment Method</div>

            <div class="img-arr">
              <div class="img-arr-item"></div>
            </div>
            <div class="title">Delivery</div>
            <div class="img-arr">
              <div class="img-arr-item d1"></div>
              <div class="img-arr-item d2"></div>
            </div> -->



<!--            <div class="tel">{{telphone}}</div>
            <div class="time">{{$t('workday')}}{{worktime}}</div>
            <div class="call">
              <i class="icon iconfont iconkefu"></i>
              <span @click="showChat">{{$t('service')}}</span>
            </div>
            <div class="er-code">
              {{$t('qrcode')}}：
              <i class="icon iconfont iconshouji" @mouseenter="showCode(1)" @mouseleave="showCode(2)"></i>
              <div class="code-img" v-show="isShow">
                <img src="@/assets/images/home/qrcode.png" alt="">
              </div>
            </div> -->
			
			
            <div class="tel">Contact Us</div>
			<!-- <div class="time" @click="goShare(item)">
				<div>Tel:+86-15538955549</div>
			</div> -->
			<div class="time" @click="goShare(item)">
				<div>Email:info@sanlidaarchery.com</div>
			</div>
<!-- 			<div style="margin-top:20px;" class="time" @click="goShare(item)">
				<div class="title">USA Repair Site</div>
				<div>Western Archery</div>
			</div> -->

			
			
			
			
         </div>
        </div>
      </div>
    </div>
    <CopyRight :links="links"></CopyRight>
  </div>
</template>
<script>
import CopyRight from '@/components/common/CopyRight.vue'
import { mapState } from 'vuex'
import { log } from 'util'
export default {
  name: 'Footer',
  data() {
    return {
      telphone: '',
      worktime: '',
      settings: [],
      bottomList: [],
      links: [],
      erCode: '',
      isShow:false,
      codeImg:''
    }
  },
  computed: {
    ...mapState({
      shopMenu: state => state.shopMenu,
    }),
  },
  watch: {
    shopMenu(newVal, oldVal) {
      let shopMenu = newVal
      this.setInfo(shopMenu)
    },
  },
  components: {
    CopyRight,
  },
  methods: {
    showChat() {
      // _AIHECONG("showChat"); //合从
      // qimoChatClick() //七陌
      // window.open('http://p.qiao.baidu.com/cps/chat?siteId=7238656&userId=10953121', '_blank')
    },
    setInfo(shopMenu) {
      let settings = shopMenu.settings
      this.settings = settings
      let bottomList = shopMenu.menu.bottom
      this.bottomList = bottomList
      let links = shopMenu.link
      this.links = links
      this.settings.find(item => {
        if (item.k == 'phone') {
          this.telphone = item.val
        }
        if (item.k == 'business') {
          this.worktime = item.val
        }
        if (item.k == 'app_image') {
          this.codeImg = item.val
        }
      })
    },
    showCode(type){
      if(type==1){
        this.isShow=true;
      }else{
        this.isShow=false;
      }
    },
    // /点击
	goShare(v) {
        this.$router.push({
          path: 'contact',
        })
        return
	}
  },
  mounted() {
    if (this.shopMenu.settings) {
      this.setInfo(this.shopMenu)
    }
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/mixin.scss';
@import '@/assets/css/variable.scss';


.foot {
  background: #fff;
  padding-bottom: 40px;
  .main {
    width: 1226px;
    margin: 0 auto;
    .t {
      margin: 0 auto 20px;
      position: relative;
      &:after {
        content: '';
        display: block;
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 1px;
        background: rgba(219, 219, 219, 1);
      }
      .t-list {
        display: flex;
        justify-content: center;
        height: 30px;
        padding: 30px 0 20px;
        .t-li {
          width: 240px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          font-size: 16px;
          font-weight: 400;
          position: relative;
          vertical-align: middle;
          cursor: pointer;
          &::after {
            content: '';
            display: block;
            position: absolute;
            right: 0;
            top: 5px;
            width: 1px;
            height: 20px;
            background: rgba(219, 219, 219, 1);
          }
          &:last-of-type::after {
            display: none;
          }
          .icon {
            display: inline-block;
            vertical-align: middle;
            margin-right: 5px;
            margin-top: -1px;
            width: 20px;
            height: 20px;
            @include bg-full();
            &.zp {
              @include bg-url('~@/assets/icon/bottom-ic-1.png');
            }
            &.sh {
              @include bg-url('~@/assets/icon/bottom-ic-2.png');
            }
            &.ts {
              @include bg-url('~@/assets/icon/bottom-ic-3.png');
            }
            &.pl {
              @include bg-url('~@/assets/icon/bottom-ic-4.png');
            }
            &.js {
              @include bg-url('~@/assets/icon/bottom-ic-5.png');
            }
          }
        }
      }
    }
    .m {
      display: flex;
      justify-content: space-between;
      color: rgba(102, 102, 102, 1);
      margin: 10px auto 0;
	  padding-top:40px;
      .ml {
        display: flex;
        justify-content: flex-start;
        flex: 1;
        .mlli {
          flex: 1;
          .mlli-title {
            height: 20px;
            line-height: 20px;
            font-size: 15px;
            margin-bottom: 14px;
          }
          ul li {
            font-size: 12px;
            height: 24px;
            line-height: 24px;
            &:hover {
              color: $theme-color;
            }
          }
        }
      }
      .mr {
        width: 280px;
        border-left: 1px solid rgba(219, 219, 219, 1);
        padding: 0 10px;
        .title {
          font-weight: bold;
          font-size: 18px;
        }
        .tel {
          height: 20px;
          line-height: 1;
          font-size: 22px;
          color: rgba(234, 75, 73, 1);
          text-align: center;
          margin: 5px auto;
        }
        .time {
          height: 14px;
          font-size: 14px;
		  line-height: 26px;
          margin: 10px auto;
          text-align: center;
          color: #616161;
		  .title{
			  font-weight: bold;
			  line-height: 30px;
		  }
		  :hover{
		  	cursor:pointer;
		  }
        }
        .call {
          width: 118px;
          height: 28px;
          margin: 10px auto 0;
          background: rgba(255, 255, 255, 1);
          border: 1px solid rgba(234, 75, 73, 1);
          color: $theme-color;
          font-size: 12px;
          line-height: 26px;
          text-align: center;
          cursor: pointer;
          &:hover {
            color: #fff;
            background: $theme-color;
          }
          .icon {
            top: 1px;
            position: relative;
            margin-right: 2px;
          }
        }
        .er-code {
          text-align: center;
          margin-top: 10px;
          color: #616161;
          font-size: 12px;
          position: relative;
          .icon {
            font-size: 16px;
            cursor: pointer;
            &:hover {
              color: $theme-color;
            }
          }
        }
        .code-img {
          width: 170px;
          height: 180px;
          z-index: 2;
          position: absolute;
          top: 20px;
          left: 100px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}


.img-arr-item{
  width: 60px;
  height: 40px;
  background: url('~@/assets/images/home/icons.png') no-repeat;
  background-position: -151px -400px;
}

.img-arr-item.d1 {
  background-position: 4px -280px;
}

.img-arr-item.d2 {
  background-position: 4px -222px;
}

.img-arr{
  display: flex;
  align-items: center;
  margin: 10px 0;
  .img-arr-item {
    margin-right: 10px;
  }
}
</style>
